export const products = [
  {
    id: 1,
    name: "BLACK STOGIC Graphics five-sleeve T-shirt",
    description: "Be still. Be strong. Be stojic— an oversized graphic T-shirt that speaks volumes in silence.",
    price: 649,
    discount: 0.0,
    cashOnDelivery: false,
    deliveryCharge: 0,
    returnPolicy: 0,
    replacementPolicy: 0,
    images: {
      "Black": [
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554905/I36A5626_2_futjw8.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554911/I36A5628_2_qtoij6.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554911/I36A5635_jqkvdj.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554911/I36A5630_2_jfrotn.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554912/I36A6023_gjfjuu.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554912/I36A6025_n7loso.jpg"
      ],
    },
    sizes: ["S", "M", "L", "XL"],
    colors: ["Black"],
    variants: [
      { size: "S", color: "Black", quantity: 10, price: 50, discount: 0.2 },
      { size: "M", color: "Black", quantity: 15, price: 50, discount: 0.2 },
      { size: "L", color: "Black", quantity: 12, price: 50, discount: 0.2 },
      { size: "XL", color: "Black", quantity: 8, price: 50, discount: 0.2 }
    ],
    sizeChart: [
      { size: "S", chest: 36, length: 26, shoulder: 8 },
      { size: "M", chest: 38, length: 27, shoulder: 9 },
      { size: "L", chest: 42, length: 28, shoulder: 10 },
      { size: "XL", chest: 46, length: 29, shoulder: 10.5 }
    ]
  },
  {
    id: 2,
    name: "ART IS LIFE white five-sleeve T-shirt",
    description: "Art moves like a wild horse — unpredictable, bold, and free, just like our white graphic printed five-sleeve T-shirt that turns raw expression into wearable rebellion",
    price: 749,
    discount: 0.0,
    cashOnDelivery: true,
    deliveryCharge: 0,
    returnPolicy: 15,
    replacementPolicy: 5,
    images: {
      "White": [
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554920/I36A5581_lt5yee.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554918/I36A5588_zp0bnv.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554921/I36A5594_oiuxli.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554921/I36A5590_vm06o7.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554922/I36A5688_nio96g.jpg"
      ]
    },
    sizes: ["S", "M", "L", "XL"],
    colors: ["White"],
    variants: [
      { size: "M", color: "White", quantity: 10, price: 2999, discount: 0.15 },
      { size: "L", color: "White", quantity: 8, price: 2999, discount: 0.15 },
      { size: "XL", color: "White", quantity: 5, price: 2999, discount: 0.15 }
    ],
    sizeChart: [
      { size: "S", chest: 36, length: 26, shoulder: 8 },
      { size: "M", chest: 38, length: 27, shoulder: 9 },
      { size: "L", chest: 42, length: 28, shoulder: 10 },
      { size: "XL", chest: 46, length: 29, shoulder: 10.5 }
    ]
  },
  {
    id: 3,
    name: "RED VICE ECHOES five-sleeve T-shirt",
    description: "Bold voices, vice echoes — five-sleeve T-shirts designed for Gen Z rebels who turn up the volume and rewrite the rules of fashion",
    price: 649,
    discount: 0.0,
    cashOnDelivery: false,
    deliveryCharge: 0,
    returnPolicy: 10,
    replacementPolicy: 3,
    images: {
      "Red": [
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554918/I36A5373_yeneqm.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554917/I36A5383_lfwknm.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554917/I36A5868_k4qajl.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554918/I36A5380_zuusnf.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554918/I36A6056_doorpt.jpg"
      ]


    },
    sizes: ["S", "M", "L", "XL"],
    colors: ["Red"],
    variants: [
      { size: "S", color: "Red", quantity: 15, price: 1999, discount: 0.25 },
      { size: "M", color: "Red", quantity: 12, price: 1999, discount: 0.25 },
      { size: "L", color: "Red", quantity: 10, price: 1999, discount: 0.25 }
    ],
    sizeChart: [
      { size: "S", chest: 36, length: 26, shoulder: 8 },
      { size: "M", chest: 38, length: 27, shoulder: 9 },
      { size: "L", chest: 42, length: 28, shoulder: 10 },
      { size: "XL", chest: 46, length: 29, shoulder: 10.5 }
    ]
  },
  {
    id: 4,
    name: "BROWN Minimal five-sleeve T-shirt",
    description: "Classic thread, timeless confidence — embodied in every minimal T-shirt designed for effortless style and quiet strength",
    price: 649,
    discount: 0.0,
    cashOnDelivery: false,
    deliveryCharge: 0,
    returnPolicy: 10,
    replacementPolicy: 3,
    images: {
      "Brown": [
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554913/I36A5602_n9h84t.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554912/I36A5612_zdch27.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554912/I36A5607_qcxtnw.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554913/I36A5610_iioqhg.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554912/I36A5473_xi4slw.jpg"
      ]
    },
    sizes: ["S", "M", "L", "XL"],
    colors: ["Brown"],
    variants: [
      { size: "S", color: "Brown", quantity: 15, price: 1999, discount: 0.25 },
      { size: "M", color: "Brown", quantity: 12, price: 1999, discount: 0.25 },
      { size: "L", color: "Brown", quantity: 10, price: 1999, discount: 0.25 }
    ],
    sizeChart: [
      { size: "S", chest: 36, length: 26, shoulder: 8 },
      { size: "M", chest: 38, length: 27, shoulder: 9 },
      { size: "L", chest: 42, length: 28, shoulder: 10 },
      { size: "XL", chest: 46, length: 29, shoulder: 10.5 }
    ]
  },
  {
    id: 5,
    name: "LAYNE RED Black five-sleeve T-shirt",
    description: "Own the bold street style — Layne red with identity in a five-sleeve graphic black printed T-shirt",
    price: 699,
    discount: 0.0,
    cashOnDelivery: false,
    deliveryCharge: 0,
    returnPolicy: 10,
    replacementPolicy: 3,
    images: {
      "Black": [
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554903/I36A5639_2_saucfa.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554904/I36A5645_2_swjqeh.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554905/I36A5642_2_ppbnnb.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554905/I36A5647_b5ckqt.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554904/I36A6058_ybo3il.jpg"
      ]
    },
    sizes: ["S", "M", "L", "XL"],
    colors: ["Black"],
    variants: [
      { size: "S", color: "Black", quantity: 15, price: 1999, discount: 0.25 },
      { size: "M", color: "Black", quantity: 12, price: 1999, discount: 0.25 },
      { size: "L", color: "Black", quantity: 10, price: 1999, discount: 0.25 }
    ],
    sizeChart: [
      { size: "S", chest: 36, length: 26, shoulder: 8 },
      { size: "M", chest: 38, length: 27, shoulder: 9 },
      { size: "L", chest: 42, length: 28, shoulder: 10 },
      { size: "XL", chest: 46, length: 29, shoulder: 10.5 }
    ]
  },
  {
    id: 6,
    name: "THE DRAGON CREAM five-sleeve T-shirt",
    description: "Dragon don’t blend — oversized cream  T-shirts built to stand out, not fit in.",
    price: 799,
    discount: 0.0,
    cashOnDelivery: false,
    deliveryCharge: 0,
    returnPolicy: 10,
    replacementPolicy: 3,
    images: {
      "Cream": [
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554915/I36A5519_f1ozzo.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554916/I36A5516_zs9ltk.jpg",
        "https://res.cloudinary.com/dlvepbxcg/image/upload/v1747554916/I36A5525_rnr0xp.jpg"
      ]
    },
    sizes: ["S", "M", "L", "XL"],
    colors: ["Cream"],
    variants: [
      { size: "S", color: "Cream", quantity: 15, price: 1999, discount: 0.25 },
      { size: "M", color: "Cream", quantity: 12, price: 1999, discount: 0.25 },
      { size: "L", color: "Cream", quantity: 10, price: 1999, discount: 0.25 }
    ],
    sizeChart: [
      { size: "S", chest: 36, length: 26, shoulder: 8 },
      { size: "M", chest: 38, length: 27, shoulder: 9 },
      { size: "L", chest: 42, length: 28, shoulder: 10 },
      { size: "XL", chest: 46, length: 29, shoulder: 10.5 }
    ]
  }
  
  
];